<template>
	<div>
		<app-overlay-loader v-if="!dataLoaded" />
		<div v-else class="content-wrapper">
			<div class="row">
				<div class="col-sm-12 col-md-6">
					<app-breadcrumb :button="{ label: $t('back'), url: urlGenerator(`crm/warehouse/list`) }"
						:directory="[$t('contacts'), name]" :icon="'users'" :page-title="name" />
				</div>
			</div>
			<div class="row">
				<div class="col-12">
 
                            <app-warehouse-info class="mb-primary" :details-data="formData"
                                :details-sync-url="`crm/warehouses/${formData.id}`" @update-request="updateRequest" />
                 
					
				</div>
				<div class="col-12">
					<div class="row">
						<div class="col-xl-4 col-12 mb-primary">
							<div class="card border-0 card-with-shadow">
								<div
									class="card-header bg-transparent p-primary d-flex justify-content-between align-items-center">
									<h5 class="card-title text-muted mb-0">{{ $t('warehouse_item_1') }}</h5>
									<div>
										<button type="button" class="btn btn-primary btn-with-shadow"
											data-toggle="modal" @click="addOper(1)">
											{{ $t("add_warehouse_item") }}
										</button>
									</div>
								</div>
								<div class="card-body p-0">
									<div class="card-oper" v-if="(formData.pre.qty > 0)">
										<app-table v-if="loadPre" :id="tableId" :options="optionsPre" @action="getAction" />
										<app-overlay-loader v-else />
									</div>
									<div class="p-primary" v-else>
										{{ $t('no_warehouse_item_card') }}
									</div>
								</div>
							</div>
						</div>
						<div class="col-xl-4 col-12 mb-primary">
							<div class="card border-0 card-with-shadow">
								<div
									class="card-header bg-transparent p-primary d-flex justify-content-between align-items-center">
									<h5 class="card-title text-muted mb-0">{{ $t('warehouse_item_2') }}</h5>
									<div>
										<button type="button" class="btn btn-primary btn-with-shadow"
											data-toggle="modal" @click="addOper(2)">
											{{ $t("add_warehouse_item") }}
										</button>
									</div>
								</div>
								<div class="card-body p-0">
									<div class="card-oper" v-if="(formData.rase.qty > 0)">
										<app-table v-if="loadRase" :id="tableId" :options="optionsRase" @action="getAction" />
										<app-overlay-loader v-else />
									</div>
									<div class="p-primary" v-else>
										{{ $t('no_warehouse_item_card') }}
									</div>
								</div>
							</div>
						</div>
						<div class="col-xl-4 col-12 mb-primary">
							<div class="card border-0 card-with-shadow">
								<div
									class="card-header bg-transparent p-primary d-flex justify-content-between align-items-center">
									<h5 class="card-title text-muted mb-0">{{ $t('warehouse_item_3') }}</h5>
									<div>
										<button type="button" class="btn btn-primary btn-with-shadow"
											data-toggle="modal" @click="addOper(3)">
											{{ $t("add_warehouse_item") }}
										</button>
									</div>
								</div>
								<div class="card-body p-0">
									<div class="card-oper" v-if="(formData.ord.qty > 0)">
										<app-table v-if="loadOrd" :id="tableId" :options="optionsOrd" @action="getAction" />
										<app-overlay-loader v-else />
									</div>
									<div class="p-primary" v-else>
										{{ $t('no_warehouse_item_card') }}
									</div>
								</div>
							</div>
						</div>
						
					</div>
				</div>
			</div>
		</div>
		<app-warehouse-item-modal
      v-if="isWarehouseModalActive"
      :table-id="tableId"
      :type="type"
      :warehouse="formData.id"
      :selected-url="selectedUrlWr"
      @close-modal="closeModal"
    />
  
    <app-confirmation-modal
      v-if="confirmationModalActive"
      modal-id="warehouse-delete-modal"
      @confirmed="confirmed"
      @cancelled="cancelled"
    />
	</div>
</template>

<script>
import {FormMixin} from "@core/mixins/form/FormMixin.js";
import {formatDateToLocal, onlyTime, onlyTimeFromTime, textTruncate, urlGenerator, numberWithCurrencyMuseum} from "@app/Helpers/helpers";
import { DeleteMixin } from "@app/Mixins/Global/DeleteMixin";
export default {
	props: ["selectedUrl"],
	name: "WarehouseDetails",
	mixins: [FormMixin, DeleteMixin],


	data() {
		return {
			urlGenerator,
            numberWithCurrencyMuseum,
			isWarehouseModalActive: false,
			confirmationModalActive: false,
			dataLoaded: false,
            type: '',
			loadPre: false,
			loadRase: false,
			loadOrd: false,
			loadRenewe: false,
			preLoader: false,
			tableId: 'renewe-modal',
			isDealModalActive: false,
			isNoteModal: false,
			warehouseActivitiesModal: false,
			formData: {},
			appTapShow: false,
			isComponent: true,
			name: "",
			selectedUrlWr: "",
			editedUrl: "",
			activitiesList: [],
			isfileNoteFilter: true,

			// Tab Start
			


			rowData: null,
			dealNoteModal: false,
			noteRowData: null,
			value: "",
			formatDateToLocal,
			onlyTimeFromTime,
			onlyTime,
			textTruncate,
			options: {},
    
		};
	},
	computed: {
		

		
	},
	methods: {
		

       
		closeModal() {
			this.isWarehouseModalActive = false;
            this.type = '';
            this.selectedUrlWr = "";
			$("#warehouse-modal").modal("hide");
            this.updateRequest();
		},
		afterSuccessFromGetEditData(response) {
			this.formData = response.data;
			this.name = this.formData.name;
			
            
			this.dataLoaded = true;
			this.getOperPre();
			this.getOperRase();
			this.getOperOrd();
		},
		addOper(id){
			this.isWarehouseModalActive = true;
            this.type = id;
		},

		setUser() {
			this.user = {
				full_name: window.user.full_name,
				img: window.user.profile_picture
					? urlGenerator(window.user.profile_picture.path)
					: urlGenerator("/images/profile.png"),
				status: this.$t("online"),
				role: this.$t(window.user.roles[0].name),
			};
		},
		
        getOperPre() {
            this.optionsPre = {
                name: this.$t("oper_pre_table"),
                url: "crm/warehouse-items?type=1&items=" + this.formData.id,
                showHeader: true,
                countView: false,
                columns: [
                    {
                        title: this.$t("warehouse_qty"),
                        type: "custom-html",
                        key: "qty",
                        modifier: (value, row) => {
                            return value;
                        },
                    },
                    {
                        title: this.$t("price_sum"),
                        type: "custom-html",
                        key: "price",
                        modifier: (value, row) => {
                            return this.numberWithCurrencyMuseum(value);
                        },
                    },
                    {
                        title: this.$t("warehouse_descriptions_sh"),
                        type: "custom-html",
                        key: "descriptions",
                        modifier: (value, row) => {
                            return value
                                ? `<span class="">${value
                                }</span>`
                                : "-";
                        },
                    },
                    {
                        title: this.$t("action"),
                        type: "action",
                        key: "invoice",
                        isVisible: true,
                    },

                ],

                showSearch: false,
                showFilter: false,
                paginationType: "pagination",
                responsive: false,
                rowLimit: 10,
                showAction: true,
                orderBy: "desc",
                actionType: "dropdown",
                actions: [
                    {
                        title: this.$t("edit"),
                        icon: "edit",
                        type: "modal",
                        component: "app-warehouse-modal",
                        modalId: "warehouse-modal",
                        url: "",
                    },
                    {
                        title: this.$t("delete"),
                        icon: "trash",
                        type: "modal",
                        component: "app-confirmation-modal",
                        modalId: "warehouse-delete-modal",
                        url: "",
                    },

                ],

            };
            this.loadPre = true;
        },
        getOperRase() {
            this.optionsRase = {
                name: this.$t("oper_rase_table"),
                url: "crm/warehouse-items?type=2&items=" + this.formData.id,
                showHeader: true,
                countView: false,
                columns: [
                    {
                        title: this.$t("warehouse_qty"),
                        type: "custom-html",
                        key: "qty",
                        modifier: (value, row) => {
                            return value;
                        },
                    },
                    {
                        title: this.$t("warehouse_descriptions_sh"),
                        type: "custom-html",
                        key: "descriptions",
                        modifier: (value, row) => {
                            return value
                                ? `<span class="">${value
                                }</span>`
                                : "-";
                        },
                    },
                    {
                        title: this.$t("action"),
                        type: "action",
                        key: "invoice",
                        isVisible: true,
                    },

                ],

                showSearch: false,
                showFilter: false,
                paginationType: "pagination",
                responsive: false,
                rowLimit: 10,
                showAction: true,
                orderBy: "desc",
                actionType: "dropdown",
                actions: [
                    {
                        title: this.$t("edit"),
                        icon: "edit",
                        type: "modal",
                        component: "app-warehouse-modal",
                        modalId: "warehouse-modal",
                        url: "",
                    },
                    {
                        title: this.$t("delete"),
                        icon: "trash",
                        type: "modal",
                        component: "app-confirmation-modal",
                        modalId: "warehouse-delete-modal",
                        url: "",
                    },

                ],

            };
            this.loadRase = true;
        },
        getOperOrd() {
            this.optionsOrd = {
                name: this.$t("oper_ord_table"),
                url: "crm/warehouse-items?type=3&items=" + this.formData.id,
                showHeader: true,
                countView: false,
                columns: [
                    {
                        title: this.$t("warehouse_qty"),
                        type: "custom-html",
                        key: "qty",
                        modifier: (value, row) => {
                            return value;
                        },
                    },
                    {
                        title: this.$t("price_sum"),
                        type: "custom-html",
                        key: "price",
                        modifier: (value, row) => {
                            return this.numberWithCurrencyMuseum(value);
                        },
                    },
                    {
                        title: this.$t("warehouse_descriptions_sh"),
                        type: "custom-html",
                        key: "descriptions",
                        modifier: (value, row) => {
                            return value
                                ? `<span class="">${value
                                }</span>`
                                : "-";
                        },
                    },
                    {
                        title: this.$t("action"),
                        type: "action",
                        key: "invoice",
                        isVisible: true,
                    },

                ],

                showSearch: false,
                showFilter: false,
                paginationType: "pagination",
                responsive: false,
                rowLimit: 10,
                showAction: true,
                orderBy: "desc",
                actionType: "dropdown",
                actions: [
                    {
                        title: this.$t("edit"),
                        icon: "edit",
                        type: "modal",
                        component: "app-warehouse-modal",
                        modalId: "warehouse-modal",
                        url: "",
                    },
                    {
                        title: this.$t("delete"),
                        icon: "trash",
                        type: "modal",
                        component: "app-confirmation-modal",
                        modalId: "warehouse-delete-modal",
                        url: "",
                    },

                ],

            };
            this.loadOrd = true;
        },


        getAction(rowData, actionObj, active) {
            if (actionObj.title == this.$t("edit")) {
                this.selectedUrlWr = `crm/warehouse-items/${rowData.id}`;
                this.isWarehouseModalActive = true;
                this.type = rowData.type_id;
            } else if (actionObj.title == this.$t("delete")) {
                this.deleteUrl = `crm/warehouse-items/${rowData.id}`;
                this.confirmationModalActive = true;
            }
        },


		updateRequest() {
			this.isComponent = false;
			this.axiosGet(this.selectedUrl).then((response) => {
				this.formData = response.data;
				this.name = this.formData.name;
				this.isComponent = true;
			}).catch((error) => console.log(error));
		},

		
	
		
		

	},

	mounted() {
		
		this.setUser();
		//this.$store.dispatch("getWarehouse");

		
		
	},
};
</script>

<style>
.card-renewe .datatable .table-responsive {
  min-height: auto !important;
}
</style>


